import { Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FcViewDetails } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import Toast from '../../helpers/Toast';
import { ProjectsFromEquipmentRequestDTO } from '../../models/Equipment/ProjectsFromEquipmentRequestDTO';
import { ProjectsFromEquipmentResponseDTO } from '../../models/Equipment/ProjectsFromEquipmentResponseDTO';
import { CreateProjectDTO } from '../../models/Project/CreateProjectDTO';
import { EquipmentService } from '../../services/EquipmentService';
import { ProjectService } from '../../services/ProjectService';
import TableComponent from '../TableComponent';

type  ProjectsFromEquipmentProps = {
    EquipmentErpId: string,
}

function ProjectsFromEquipment(props: ProjectsFromEquipmentProps) {
    
    const equipmentService = new EquipmentService();
    const projectService = new ProjectService();
    const navigate = useNavigate();
    const [projects, setProjects] = useState<ProjectsFromEquipmentResponseDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "Nome",
                accessor: "description",
                width: 20,
            },
            {
                Header: "Descrição",
                accessor: "notes",
                width: 25,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    return (
                        <Tooltip
                            title="Ver Detalhes"
                            aria-label="Ver Detalhes"
                            enterNextDelay={500}
                            enterDelay={500}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    flexDirection: "column",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    // Verificamos se cada campo 'relacionado' existe antes de passar para a função
                                    const erpId = props.cell.row.original.erpId || null;
                                    const description = props.cell.row.original.description || null;
                                    const startDate = props.cell.row.original.startDate || null;
                                    const budgetSellingPrice = props.cell.row.original.budgetSellingPrice || null;
                                    const budgetCostPrice = props.cell.row.original.budgetCostPrice || null;
                                    const notes = props.cell.row.original.notes || null;
                                    const clientId = props.cell.row.original.clientId || null;

                                    createProject(erpId, description, startDate, budgetSellingPrice, budgetCostPrice, notes, clientId);
                                }}
                            >
                                <FcViewDetails className="icons" />
                            </div>
                        </Tooltip>
                    );
                },
                width: 2,
            },
           
        ],
        [isButtonCreateLoading],
    );

    const createProject = async (erpId: string, description: string, startDate: Date, budgetSellingPrice: number, budgetCostPrice: number, notes: string, clientId: string) => {
        var sendData: CreateProjectDTO = {
            erpId: erpId,
            description: description,
            startDate: startDate,
            budgetSellingPrice: budgetSellingPrice,
            budgetCostPrice: budgetCostPrice,
            notes: notes,
            clientId: clientId
        }
        setIsButtonCreateLoading(true);
        var response = await projectService.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Project/${response.obj}`);
    }

    const GetProjects = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data : ProjectsFromEquipmentRequestDTO = {
            equipmentErpId: String(props.EquipmentErpId),
            currentPage: currentPage,
            pageSize: pageSize,
        }

        var response = await equipmentService.GetProjectsFromEquipment(data);

        if(response.success === false)
        {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return; 
        }

        setProjects(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(()=> {
        if(props.EquipmentErpId !== "")
        {
            GetProjects(currentPage ?? 1, pageSize ?? 5)
        }
    }, [props.EquipmentErpId, currentPage, pageSize])

  return (
        <div>
            <label style={{ margin: "0px" }}></label>
             <TableComponent 
                    columns={columns} 
                    data={projects}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetProjects} 
                    initialSortBy={[]}
                    disableSortBy={true}
                />    
        </div>
    
  )
}

export default ProjectsFromEquipment